import { render, staticRenderFns } from "./region.vue?vue&type=template&id=3612b802&scoped=true&"
import script from "./region.vue?vue&type=script&lang=ts&"
export * from "./region.vue?vue&type=script&lang=ts&"
import style0 from "./region.vue?vue&type=style&index=0&id=3612b802&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3612b802",
  null
  
)

export default component.exports